import { render, staticRenderFns } from "./PlaytestV2.vue?vue&type=template&id=4e25d57c&scoped=true&"
import script from "./PlaytestV2.vue?vue&type=script&lang=js&"
export * from "./PlaytestV2.vue?vue&type=script&lang=js&"
import style0 from "./PlaytestV2.vue?vue&type=style&index=0&id=4e25d57c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e25d57c",
  null
  
)

export default component.exports